/**
 * index.js — entry point.
 *
 * createRoot, not hydrateRoot. Nothing is prerendered here — this bundle is
 * only ever served inside a Telegram webview, which is not crawled, so
 * there is no SEO reason to prerender and no markup to hydrate against.
 */

import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";

createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
